function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 125,
  r: 100,
  fill: "url(#paint0_radial)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "border",
  cx: 125,
  cy: 125,
  r: 105,
  stroke: "white",
  strokeWidth: 10
})), /*#__PURE__*/React.createElement("mask", {
  id: "path-3-inside-1",
  fill: "white"
}, /*#__PURE__*/React.createElement("path", {
  d: "M147 134C147 137.02 146.405 140.011 145.249 142.802C144.093 145.592 142.399 148.128 140.263 150.263C138.128 152.399 135.592 154.093 132.802 155.249C130.011 156.405 127.02 157 124 157C120.98 157 117.989 156.405 115.198 155.249C112.408 154.093 109.872 152.399 107.737 150.263C105.601 148.128 103.907 145.592 102.751 142.802C101.595 140.011 101 137.02 101 134L124 134H147Z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M147 134C147 137.02 146.405 140.011 145.249 142.802C144.093 145.592 142.399 148.128 140.263 150.263C138.128 152.399 135.592 154.093 132.802 155.249C130.011 156.405 127.02 157 124 157C120.98 157 117.989 156.405 115.198 155.249C112.408 154.093 109.872 152.399 107.737 150.263C105.601 148.128 103.907 145.592 102.751 142.802C101.595 140.011 101 137.02 101 134L124 134H147Z",
  fill: "white",
  stroke: "#4F4D48",
  strokeWidth: 10,
  mask: "url(#path-3-inside-1)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M72.2475 88.0927C72.414 87.1162 71.7718 86.176 70.7868 86.0708C67.2856 85.6971 63.7679 86.2493 60.6102 87.685C57.5088 89.0952 54.8889 91.2967 53.0072 94.0507C52.4161 94.9159 52.7681 96.0737 53.6901 96.5717C54.6129 97.07 55.7556 96.7165 56.3688 95.8657C57.8701 93.7827 59.9059 92.1141 62.2957 91.0274C64.7146 89.9276 67.3951 89.47 70.0777 89.6838C71.1013 89.7653 72.0749 89.105 72.2475 88.0927Z",
  fill: "#4F4D48"
}), /*#__PURE__*/React.createElement("path", {
  d: "M175.471 88.0927C175.304 87.1162 175.946 86.176 176.931 86.0708C180.432 85.6971 183.95 86.2493 187.108 87.685C190.209 89.0952 192.829 91.2967 194.711 94.0507C195.302 94.9159 194.95 96.0737 194.028 96.5717C193.105 97.07 191.962 96.7165 191.349 95.8657C189.848 93.7827 187.812 92.1141 185.422 91.0274C183.003 89.9276 180.323 89.47 177.64 89.6838C176.617 89.7653 175.643 89.105 175.471 88.0927Z",
  fill: "#4F4D48"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 177.5,
  cy: 115.5,
  r: 10.5,
  fill: "#4F4D48"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 71.5,
  cy: 115.5,
  r: 10.5,
  fill: "#4F4D48"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: -13,
  y: -10,
  width: 276,
  height: 276,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 12,
  operator: "erode",
  in: "SourceAlpha",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 20
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.992157 0 0 0 0 0.796078 0 0 0 0 0.356863 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(-14 68) rotate(21.3916) scale(220.705)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.42
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.230076,
  stopColor: "#FFE927"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.642194,
  stopColor: "#FFE43B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.989483,
  stopColor: "#FFD66D"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 250,
  height: 250,
  fill: "white"
})));

var SvgVeryhappyFace = function SvgVeryhappyFace(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVeryhappyFace, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Very happy Face.89c17a0c.svg";
export { ForwardRef as ReactComponent };